<template>
	<div class="page-container">
		<ArticleList :bid="'question'"></ArticleList>
	</div>
</template>

<script>
import ArticleList from '@/components/Board/articleList'


export default {
	name: 'BoardQuestion',
	components: {
		ArticleList
	},
	data () {
		return {
			
		}	
	},
	created: function() {

	},

	mounted() {
	
	},

}
</script>
